<template>

  <vue-final-modal v-model="showM" classes="modal-container" content-class="modal-content-f w800">
    <div class="modal-header">
      <b>Detail lektora</b>
      <button type="button" class="close" @click.prevent="hideModal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal__content">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Jméno</label>
            <input type="text" v-model="user.first_name" class="form-control"/>
          </div>

          <div class="form-group">
            <label>příjmení</label>
            <input type="text" v-model="user.last_name" class="form-control"/>
          </div>

          <div class="form-group">
            <label>e-mail</label>
            <input type="text" v-model="user.email" class="form-control"/>
          </div>

          <div class="form-group">
            <label>heslo</label>
            <input type="password" v-model="user.password" class="form-control"/>
            <p class="small "><i>Změní se jen při vyplnění hesla</i></p>
          </div>

        </div>


        <div class="col-md-6">
          <profile-image @imageChange="handleImageChange" :src="user.profile_image_url_big"></profile-image>
        </div>

      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>KK sazba za lekci 45 minut </label>
            <div class="input-group">
              <input type="text" v-model="user.rate_45" class="form-control"/>
              <div class="input-group-append">
                <span class="input-group-text">CZK</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>KK sazba za lekci 22,5 minut</label>
            <div class="input-group">
              <input type="text" v-model="user.rate_22" class="form-control"/>
              <div class="input-group-append">
                <span class="input-group-text">CZK</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Onlajnovka, sazba za lekci 45 minut</label>
            <div class="input-group">
              <input type="text" v-model="user.rate_onla_45" class="form-control"/>
              <div class="input-group-append">
                <span class="input-group-text">CZK</span>
              </div>
            </div>
          </div>
        </div>

      </div>


      <!-- LL Sazby sekce -->
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="form-group">
            <label class="d-flex align-items-center">
              <input type="checkbox" v-model="user.ll_lector" class="mr-2" />
              <strong>LL Lektor (Lekce Lekce)</strong>
            </label>
            <small class="form-text text-muted">Označte, pokud je tento lektor aktivní pro individuální výuku LL</small>
          </div>
        </div>
      </div>

      <!-- Active status -->
      <div class="row mt-2">
        <div class="col-md-12">
          <div class="form-group">
            <label class="d-flex align-items-center">
              <input type="checkbox" v-model="user.active" class="mr-2" />
              <strong>Active</strong>
            </label>
            <small class="form-text text-muted">Uncheck to mark lector as inactive (will not appear in dropdowns)</small>
          </div>
        </div>
      </div>

      <div class="row" v-if="user.ll_lector">
        <div class="col-md-12 mb-2">
          <h6 class="text-muted">LL Sazby za lekci</h6>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label>Sazba za 30 minut</label>
            <div class="input-group">
              <input type="number" v-model="user.rate_ll_30" class="form-control" step="0.01"/>
              <div class="input-group-append">
                <span class="input-group-text">CZK</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label>Sazba za 45 minut</label>
            <div class="input-group">
              <input type="number" v-model="user.rate_ll_45" class="form-control" step="0.01"/>
              <div class="input-group-append">
                <span class="input-group-text">CZK</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label>Sazba za 60 minut</label>
            <div class="input-group">
              <input type="number" v-model="user.rate_ll_60" class="form-control" step="0.01"/>
              <div class="input-group-append">
                <span class="input-group-text">CZK</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label>Sazba za 80 minut</label>
            <div class="input-group">
              <input type="number" v-model="user.rate_ll_80" class="form-control" step="0.01"/>
              <div class="input-group-append">
                <span class="input-group-text">CZK</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label>Sazba za 90 minut</label>
            <div class="input-group">
              <input type="number" v-model="user.rate_ll_90" class="form-control" step="0.01"/>
              <div class="input-group-append">
                <span class="input-group-text">CZK</span>
              </div>
            </div>
          </div>
        </div>
      </div>



    </div>



    <!--
    <div class="row">
        <div class="col-md-12">
            <label class="mr-5"><input type="checkbox" v-model="l1" />Level 1</label>
            <label class="mr-5"><input type="checkbox" v-model="l2" />Level 2</label>
            <label class="mr-5"><input type="checkbox" v-model="l3" />Level 3</label>
        </div>
    </div>
    -->

    <div class="modal__action">
      <button class="btn btn-primary" @click="handleSaveChanges">uložit změny</button>
      <button class="btn btn-outline-dark ml-4" @click="hideModal">zrušit</button>
    </div>
  </vue-final-modal>
</template>

<script>
import modalKkMixin from "./conversation-club/modal-kk-mixin";
import ProfileImage from "./conversation-club/profile-image.vue";
import axios from "axios";

export default {
  components: {ProfileImage},
  mixins: [modalKkMixin],
  name: "modal-lector",
  props: ['user'],
  watch: {
   /* user() {
      this.showM = true
      if (this.user.kk_levels.indexOf('1') >= 0)
        this.l1 = true
      else
        this.l1 = false

      if (this.user.kk_levels.indexOf('2') >= 0)
        this.l2 = true
      else
        this.l2 = false

      if (this.user.kk_levels.indexOf('3') >= 0)
        this.l3 = true
      else
        this.l3 = false

    }*/
  },
  data() {
    return {
      avatar: '',
      l1: false, l2: false, l3: false
    }
  },
  methods: {


    handleSaveChanges() {
      const formData = new FormData()
      if (this.user.id && this.user.id > 0) {
        formData.append('id', this.user.id)
      }

      let levels = []
      if (this.l1) levels.push(1)
      if (this.l2) levels.push(2)
      if (this.l3) levels.push(3)


      formData.append('user[last_name]', this.user.last_name)
      formData.append('user[first_name]', this.user.first_name)
      formData.append('user[email]', this.user.email)
      formData.append('user[kk_levels]', levels.join(','))

      formData.append('user[rate_45]', this.user.rate_45)
      formData.append('user[rate_22]', this.user.rate_22)
      formData.append('user[rate_onla_45]', this.user.rate_onla_45)

      // Active status
      formData.append('user[active]', this.user.active ? true : false)

      // LL sazby
      formData.append('user[ll_lector]', this.user.ll_lector ? true : false)
      if (this.user.ll_lector) {
        formData.append('user[rate_ll_30]', this.user.rate_ll_30 || 0)
        formData.append('user[rate_ll_45]', this.user.rate_ll_45 || 0)
        formData.append('user[rate_ll_60]', this.user.rate_ll_60 || 0)
        formData.append('user[rate_ll_80]', this.user.rate_ll_80 || 0)
        formData.append('user[rate_ll_90]', this.user.rate_ll_90 || 0)
      }



      if (this.avatar) {
        formData.append("user[profile_image]", this.avatar, this.avatar.name)
      }
      if (this.user.password) {
        formData.append('user[password]', this.user.password)
      }

      axios.post('/lectors/update', formData).then(response => {
        this.user.profile_image_url = response.data.profile_image
        this.$emit('userUpdated')
        this.hideModal()
      })
    },
    handleImageChange(f) {
      this.avatar = f
    }
  }

}
</script>

<style scoped>

</style>